"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
//
var AutoDataProvider = /** @class */ (function (_super) {
    __extends(AutoDataProvider, _super);
    function AutoDataProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // add the dealerId onto the window object
    AutoDataProvider.prototype.patchWindowWithDealerCode = function (config) {
        // @ts-ignore
        window._t_jd_d_c = '{' + config.dealerId + '}'; // add dealerId to window object for GTM script
    };
    AutoDataProvider.prototype.patchWindowWithHondaConfig = function () {
        // @ts-ignore
        window._t_jd_dr = '{DR_DealerInspire}'; // add provider name to window object for GTM script
    };
    AutoDataProvider.prototype.loadGTMScript = function (gtmId) {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", gtmId);
    };
    return AutoDataProvider;
}(index_1.AnalyticsProvider));
exports.default = AutoDataProvider;
